import {type ProjectTemplate} from '../types.js'

const quickStartTemplate: ProjectTemplate = {}

export default quickStartTemplate
